const DEFAULT_TAB = 'account';

const VALID_TABS = {
  account: 'account',
  subscriptions: 'subscriptions',
};

export const getTabFromHash = () => {
  const hash = window.location.hash.slice(1);
  const params = new URLSearchParams(hash);
  const tab = params.get('tab');
  return VALID_TABS[tab] || 'account';
};

export const updateSecondaryNavActive = () => {
  const hash = window.location.hash || `#tab=${DEFAULT_TAB}`;
  const links = document.querySelectorAll('#secondaryNav a');

  links.forEach((link) => {
    link.classList.remove('ui-link_marked');
    const href = link.getAttribute('href');
    if (href && href.includes(hash)) {
      link.classList.add('ui-link_marked');
    }
  });
};
